module.exports = __webpack_public_path__ + "static/media/youtube.5acdbb59.svg";